import { useState } from "react";
import portalApi, { errMsg } from "@/lib/portalApi";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const colour = (n) => (n <= 3 ? "bg-emerald-500" : n <= 6 ? "bg-amber-500" : "bg-red-500");

export const CheckinForm = ({ onDone }) => {
  const [pain, setPain] = useState(null);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await portalApi.post("/checkin", { pain, comment });
      toast.success("Thanks — your clinician has your update");
      setPain(null); setComment("");
      onDone();
    } catch (e) { toast.error(errMsg(e, "Could not save — please try again")); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="checkin-form">
      <p className="text-sm font-semibold text-slate-700">How is your pain today? <span className="font-normal text-slate-400">(0 = no pain, 10 = worst imaginable)</span></p>
      <div className="mt-3 grid grid-cols-6 gap-1.5 sm:grid-cols-11">
        {Array.from({ length: 11 }, (_, n) => (
          <button key={n} onClick={() => setPain(n)} data-testid={`pain-score-${n}`}
            className={`h-11 rounded-lg text-sm font-bold transition-transform hover:scale-105 ${pain === n ? `${colour(n)} text-white ring-2 ring-offset-1 ring-slate-900` : "bg-slate-100 text-slate-700"}`}>{n}</button>
        ))}
      </div>
      <Textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={1000} className="mt-4" rows={3}
        placeholder="Anything you'd like your clinician to know? (optional)" data-testid="checkin-comment" />
      <Button onClick={submit} disabled={pain === null || busy} className="mt-3 w-full bg-teal-600 hover:bg-teal-700 sm:w-auto" data-testid="checkin-submit-btn">
        {busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />} Send my check-in
      </Button>
    </div>
  );
};
